module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiExt.f669abb.woff";